import gql from 'graphql-tag';

export default gql`
  mutation suspendCredentialGroup(
    $channelId: UUID!
    $credentialGroupId: String!
    $provider: String!
  ) {
    suspendCredentialGroup(
      channelId: $channelId
      credentialGroupId: $credentialGroupId
      provider: $provider
    )
  }
`;
